import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Process } from "@/components/Process";
import { Services } from "@/components/Services";
import { Offers } from "@/components/Offers";
import { Realisations } from "@/components/Realisations";
import { Trust } from "@/components/Trust";
import { Advice } from "@/components/Advice";
import { FinalCTA } from "@/components/FinalCTA";
import { ContactSection } from "@/components/ContactSection";
import { Footer } from "@/components/Footer";
import { scrollToId } from "@/lib/constants";
import { Logo } from "@/components/Logo";

export default function LandingPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const [intro, setIntro] = useState(
    () => !window.matchMedia("(prefers-reduced-motion: reduce)").matches
  );
  const [callbackModel, setCallbackModel] = useState("");

  useEffect(() => {
    if (!intro) return;
    const t = setTimeout(() => setIntro(false), 1200);
    return () => clearTimeout(t);
  }, [intro]);

  // Navigation croisée : /modeles ou autre page -> ancre de la home
  useEffect(() => {
    const state = location.state;
    if (!state) return;
    if (state.model) setCallbackModel(state.model);
    if (state.scrollTo) {
      const t = setTimeout(() => scrollToId(state.scrollTo), 500);
      return () => clearTimeout(t);
    }
  }, [location.state]);

  const goContact = () => scrollToId("contact");
  const goEstimate = () => navigate("/estimer");
  const goEstimateWith = (kind) => navigate("/estimer", { state: { accompaniment: kind } });

  return (
    <div className="App">
      <AnimatePresence>
        {intro && (
          <motion.div
            data-testid="intro-overlay"
            exit={{ y: "-100%" }}
            transition={{ duration: 0.9, ease: [0.76, 0, 0.24, 1] }}
            className="fixed inset-0 z-[100] flex items-center justify-center bg-[#F3F0E8]"
          >
            <motion.div
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
              className="flex flex-col items-center gap-5 px-6"
            >
              <Logo className="h-auto w-full max-w-sm" />
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>

      <Navbar />
      <Hero />
      <Process onStart={goEstimate} />
      <Services onDiscover={goEstimate} />
      <Offers onDiscover={goEstimateWith} />
      <Realisations />
      <Trust />
      <Advice />
      <FinalCTA onStart={goEstimate} onCallback={goContact} />
      <ContactSection preselectedModel={callbackModel} />
      <Footer />
    </div>
  );
}
